export const ArrowPrevIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.06523 6.69022L8.44023 2.31522C8.48087 2.27458 8.52913 2.24233 8.58224 2.22033C8.63535 2.19834 8.69227 2.18701 8.74976 2.18701C8.80724 2.18701 8.86417 2.19834 8.91727 2.22033C8.97038 2.24233 9.01864 2.27458 9.05929 2.31522C9.09994 2.35587 9.13218 2.40413 9.15418 2.45724C9.17618 2.51035 9.1875 2.56727 9.1875 2.62476C9.1875 2.68224 9.17618 2.73916 9.15418 2.79227C9.13218 2.84538 9.09994 2.89364 9.05929 2.93429L4.99327 6.99976L9.05929 11.0652C9.14138 11.1473 9.1875 11.2587 9.1875 11.3748C9.1875 11.4909 9.14138 11.6022 9.05929 11.6843C8.9772 11.7664 8.86585 11.8125 8.74976 11.8125C8.63366 11.8125 8.52232 11.7664 8.44023 11.6843L4.06523 7.30929C4.02455 7.26866 3.99228 7.2204 3.97026 7.16729C3.94825 7.11418 3.93691 7.05725 3.93691 6.99976C3.93691 6.94226 3.94825 6.88533 3.97026 6.83222C3.99228 6.77911 4.02455 6.73086 4.06523 6.69022Z'
        fill='currentColor'
      />
    </svg>
  );
};
